// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"e3d642ef","284":"9f3caec9","821":"fe4ca0e3"}[chunkId] + ".chunk.js";
};